module.exports = __webpack_public_path__ + "img/jiapeople.fd0991d7.png";